<template>
  <div class="animated fadeIn">
    <br />
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Costo Variable Mínimo</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>

          <b-row class="my-1">
            <b-col sm="2">
              <label style="text-aling: rigth">Ejecutivos/Asistentes</label>
            </b-col>
            <b-col sm="3">
              <b-form-select
                :options="valEjecutivos"
                v-model="datosFormulario.ejecutivo"
              >
              </b-form-select>
              <span class="error-validacion-campo">{{
                mensajeValidacionCampo.ejecutivo
              }}</span>
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="2">
              <label>Póliza</label>
            </b-col>
            <b-col sm="3">
              <!-- <b-form-group> -->
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="datosFormulario.poliza"
                  @change="consulta_poliza()"
                >
                </b-form-input>
                <b-input-group-prepend class="input-group-append">
                  <b-button
                    type="submit"
                    class="fa fa-search"
                    variant="primary"
                  ></b-button>
                </b-input-group-prepend>
              </b-input-group>
              <span class="error-validacion-campo">
                {{ mensajeValidacionCampo.poliza }}
              </span>
              <!-- </b-form-group> -->
            </b-col>
          </b-row>

          <b-row class="my-1">
            <b-col sm="2">
              <label style="text-aling: rigth">Moneda</label>
            </b-col>
            <b-col sm="3">
              <b-form-select
                :options="monedas"
                v-model="datosFormulario.moneda"
              >
              </b-form-select>
              <span class="error-validacion-campo">{{
                mensajeValidacionCampo.moneda
              }}</span>
            </b-col>
          </b-row>

          <div slot="footer">
            <div class="form-actions text-right">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar"
                    ><i class="fa fa-search"></i> Consultar</b-button
                  >
                  <b-button
                    variant="primary"
                    @click="pre_insertar"
                    style="margin-left: 10px"
                    ><i class="fa fa-eraser"></i> Limpiar</b-button
                  >
                  <b-button variant="primary" @click="descargarExcel" v-show="exportar" style="margin-left: 10px"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>


        <b-card v-if="tieneAcceso === true" v-show="data != ''? true : false">
          <div slot="header">
            <strong>Costo Variable Mínimo</strong>
          </div>
          <b-row>
            <b-col lg="6">

            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <!--
                <el-table-column
                  v-for="title in titles"
                  :prop="title.prop"
                  :min-width="title.minwidth"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                -->
                <el-table-column
                  prop = "contratante"
                  min-width = "300"
                  label = "Contratante"
                  key= "Contratante"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "poliza"
                  min-width = "80"
                  label = "Póliza"
                  key= "Póliza"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "producto"
                  min-width = "120"
                  label = "Producto"
                  key= "Producto"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "corredor"
                  min-width = "300"
                  label = "Corredor"
                  key= "Corredor"
                  align= "left"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "ejecutivo"
                  min-width = "120"
                  label = "Ejecutivo"
                  key= "Ejecutivo"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <!-- <el-table-column
                  prop = "asistente"
                  min-width = "120"
                  label = "Asistente"
                  key= "Asistente"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column> -->
                <el-table-column
                  prop = "vigencia_desde"
                  min-width = "150"
                  label = "Vigencia Desde"
                  key= "Vigencia Desde"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "vigencia_hasta"
                  min-width = "150"
                  label = "Vigencia Hasta"
                  key= "Vigencia Hasta"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "meses_periodo"
                  min-width = "150"
                  label = "Meses del Periodo"
                  key= "Meses del Periodo"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>

                <el-table-column label="Prima por Ventas" min-width="150px" align="right">
                <template slot-scope="scope">
                    <el-button
                          type="text"
                          size="mini"
                          @click="button.handler"
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.id"
                        >
                          {{ $numeral(button.name).format("0,0.00") }}
                    </el-button>
                  </template>
                </el-table-column>

                <el-table-column
                  prop = "moneda"
                  min-width = "120"
                  label = "Moneda"
                  key= "Moneda"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "costo_variable_minimo"
                  min-width = "180"
                  label = "CVM Anual"
                  key= "CVM Anual"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "prima_de_deposito"
                  min-width = "150"
                  label = "Prima de Depósito"
                  key= "Prima de Depósito"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "cumplimiento"
                  min-width = "150"
                  label = "% Cumplimiento"
                  key= "% Cumplimiento"
                  align= "right"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column
                  prop = "expirada"
                  min-width = "70"
                  label = "E"
                  key= "E"
                  align= "center"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>






    <!-- Detalle -->
    <b-modal
      title="Detalle Prima por Ventas"
      class="modal-success"
      size="xl"
      v-model="modalDetalle"

      cancel-title="Cerrar"
      ok-title="Exportar"
      @ok="descargarExcelModal();"
      @cancel="modalDetalle = false"


    >
       <data-tables ref="refTable2"
                :data="datosFormularioModal.data"
                name="table2"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titlesDinamic"
                  :prop="title.prop"
                  :min-width="title.minwidth"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
              </data-tables>

    </b-modal>




  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInformes from "@/components/services/apiInformes";
import apiBaseAsegurado from "@/components/services/apiBaseAsegurado";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";

import XLSX from "xlsx";

export default {
  name: "CostoVariableMinimo",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
  },
  data: function () {
    return {
      hasPoliza: false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },
      selectedCor: [],
      selectedDire: [],

      modalDetalle: false,

      data: [],
      nombreexcel: "CostoVariableMinimo",

      titles: [
        {
          prop: "contratante",
          label: "Contratante",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth: "80",
        },
        {
          prop: "producto",
          label: "Producto",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "corredor",
          label: "Corredor",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "ejecutivo",
          label: "Ejecutivo",
          align: "center",
          minwidth: "120",
        },
        // {
        //   prop: "asistente",
        //   label: "Asistente",
        //   align: "center",
        //   minwidth: "120",
        // },
        {
          prop: "vigencia_desde",
          label: "Vigencia Desde",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "vigencia_hasta",
          label: "Vigencia Hasta",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "meses_periodo",
          label: "Meses del Periodo",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "prima_ventas",
          label: "Prima por Ventas",
          align: "right",
          minwidth: "150",
        },
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "costo_variable_minimo",
          label: "CVM Anual",
          align: "right",
          minwidth: "180",
        },
        {
          prop: "prima_de_deposito",
          label: "Prima de Depósito",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "cumplimiento",
          label: "% Cumplimiento",
          align: "right",
          minwidth: "150",
        },
        {
          prop: "expirada",
          label: "E",
          align: "center",
          minwidth: "70",
        },

      ],

      titlesDinamic: [],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              console.log(prop);
              if (prop === 'vigencia_desde'){

                let elDate = new Date(row["vigencia_desde"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else if (prop === 'vigencia_hasta'){
                let elDate = new Date(row["vigencia_hasta"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }

            })

          }
        }
      ],

      mostrarFechas: true,

      datosFormulario: {
          ejecutivo:"",
          poliza:"",
          moneda:""
      },

      datosFormularioModal: {
          ejecutivo:"",
          poliza:"",
          moneda:"",
          data: []
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      valEjecutivos: [],
      monedas: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "id",
      },
    };
  },
  components: {
    Datepicker,
    Multiselect,
  },
  methods: {
    cargarColumnasGrilla(){
      this.titlesDinamic = [];
      let arrMeses= ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

      let mesactual = moment().month();
      let mesinicial = mesactual;

      let arrAux = [];
        arrAux["prop"] = 'contratante';
        arrAux["label"] = 'Contratante';
        arrAux["align"] = "left";
        arrAux["minwidth"] = "250";
        this.titlesDinamic.push(arrAux);

      arrAux = [];
        arrAux["prop"] = 'poliza';
        arrAux["label"] = 'Póliza';
        arrAux["align"] = "left";
        arrAux["minwidth"] = "120";
        this.titlesDinamic.push(arrAux);

      arrAux = [];
        arrAux["prop"] = 'producto';
        arrAux["label"] = 'producto';
        arrAux["align"] = "left";
        arrAux["minwidth"] = "120";
        this.titlesDinamic.push(arrAux);

      for (let step = 0; step < 12; step++) {
        let mes = (mesinicial + step) > 11? (mesinicial + step - 12) : (mesinicial + step);
        let label = arrMeses[mes];
        let prop = 'mes_' + (step > 9? step : ('0' + step));

        let arrAux = [];
        arrAux["prop"] = prop;
        arrAux["label"] = label;
        arrAux["align"] = "right";
        arrAux["minwidth"] = "150";
        this.titlesDinamic.push(arrAux);
      }

      arrAux = [];
        arrAux["prop"] = 'total_ventas';
        arrAux["label"] = 'Total';
        arrAux["align"] = "right";
        arrAux["minwidth"] = "150";
        this.titlesDinamic.push(arrAux);
    },

    customButtonsForRow(row) {
          var botones = new Array();

          var obj = new Object();
            obj.tooltip = "Detalle";
            obj.id = 1;
            obj.name= row.prima_ventas;
            obj.icon = "fa fa-eraser";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                this.detalle(row);
            }
            botones.push(obj);


          return botones;

    },

    detalle(row) {
      this.datosFormularioModal.poliza = row.poliza;
      this.datosFormularioModal.data = [];
      this.$Progress.start();
      return apiInformes
        .recuperar_CostoVariableMinimoDetalle(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          row.poliza,
          this.datosFormulario.moneda,
          this.datosFormulario.ejecutivo)
        .then((response) => {
          this.cargarColumnasGrilla();

          response.data = this.keysMinuscula(response.data);
          this.datosFormularioModal.data = response.data.res;

          this.$Progress.finish();
          this.modalDetalle = true;
        })
        .catch((error) => {
          this.$Progress.finish();
          this.mensaje = error;
          this.variant = "danger";
          this.showAlert();
        });
    },

    llenaArrayLista(data, valor, texto, isDate) {
      var arr = new Array();
      for (var i = 0; i < data.length; i++) {
        var obj = new Object();
        if (isDate) {
          obj.value = this.convierteFecha(data[i][valor]);
          obj.text = this.convierteFecha(data[i][texto]);
        } else {
          obj.value = data[i][valor].toString();
          obj.text = data[i][texto];
        }
        arr.push(obj);
      }
      return arr;
    },

    pre_insertar() {
      this.$Progress.start();
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.ejecutivo = "T";
      this.datosFormulario.poliza = "";
      this.datosFormulario.moneda = "PO";

      this.hasPoliza = false;

      return apiInformes
        .pre_insercion_CostoVariableMinimo(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == "s") {
            this.tieneAcceso = true;
          } else {
            this.tieneAcceso = false;
          }

          this.datosFormulario.ejecutivo = "T";
          this.datosFormulario.poliza = "";

          //Carga lista de ejecutivos
          var tiposEjecutivos = new Array();
          var objTodos = new Object();
          objTodos.value = "T";
          objTodos.text = "Todos";
          tiposEjecutivos.push(objTodos);

          var lista_tipos_ejecutivos = response.data.ejecutivos;
          for (var i = 0; i < lista_tipos_ejecutivos.length; i++) {
            var obj = new Object();
            obj.value = lista_tipos_ejecutivos[i]["ejecutivo"];
            obj.text = lista_tipos_ejecutivos[i]["ejecutivo"];
            tiposEjecutivos.push(obj);
          }

          this.valEjecutivos = tiposEjecutivos;

          //carga de listados
          this.monedas = this.llenaArrayLista(
            response.data.monedas,
            "codigo",
            "nombre",
            false
          );

          this.datosFormularioEstado = response.data.festado;

          this.$Progress.finish();
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();
      this.exportar = false;
      var p_email = this.$session.get("mail");

      this.datosFormulario.ejecutivo == "Todos"? "" : this.datosFormulario.ejecutivo;
      this.datosFormulario.poliza == "" ? "" : this.datosFormulario.poliza;
      this.datosFormulario.moneda == ""? "" : this.datosFormulario.moneda;

      var p_ejecutivo = this.datosFormulario.ejecutivo == "Todos"? "T" : this.datosFormulario.ejecutivo;
      var p_poliza = this.datosFormulario.poliza == ""? "0" : this.datosFormulario.poliza;
      var p_moneda = this.datosFormulario.moneda == ""? "0" : this.datosFormulario.moneda;

      return apiInformes
        .recuperar_CostoVariableMinimo(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          p_poliza,
          p_moneda,
          p_ejecutivo)
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          this.data = response.data.res;


          if (this.data != null){
            this.exportar = true;
          } else {
            this.exportar = false;
          }

          this.$Progress.finish();
        })
        .catch((error) => {
          this.$Progress.finish();
          this.mensaje = error;
          this.variant = "danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if ((column.property == "vigencia_desde" || column.property == "vigencia_hasta") && row[column.property]) {
        return this.configurarFechaLat(
          this.convierteFecha(row[column.property])
        );
      } else if ((column.property == "prima_ventas" || column.property == "mes_00" || column.property == "mes_01" || column.property == "mes_02" || column.property == "mes_03" || column.property == "mes_04" || column.property == "mes_05" || column.property == "mes_06"  || column.property == "mes_07" || column.property == "mes_08" || column.property == "mes_09" || column.property == "mes_10" || column.property == "mes_11" || column.property == "total_ventas") && row[column.property]) {
        if (row[column.property] == -1 || row[column.property] == "-1"){
          return "N/A";
        }
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else if (column.property == "costo_variable_minimo" && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0");
        }
      } else {
        return row[column.property];
      }
    },

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";


      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";

      //Data bloque 1
      for (var key in this.data) {

        if(this.data[key]["contratante"] == undefined){
          this.data[key]["contratante"] = "";
        }
        if(this.data[key]["poliza"] == undefined){
          this.data[key]["poliza"] = "";
        }
        if(this.data[key]["producto"] == undefined){
          this.data[key]["producto"] = "";
        }
        if(this.data[key]["corredor"] == undefined){
          this.data[key]["corredor"] = "";
        }
        if(this.data[key]["ejecutivo"] == undefined){
          this.data[key]["ejecutivo"] = "";
        }
        // if(this.data[key]["asistente"] == undefined){
        //   this.data[key]["asistente"] = "";
        // }
        if(this.data[key]["vigencia_desde"] == undefined){
          this.data[key]["vigencia_desde"] = "";
        }
        if(this.data[key]["vigencia_hasta"] == undefined){
          this.data[key]["vigencia_hasta"] = "";
        }
        if(this.data[key]["meses_periodo"] == undefined){
          this.data[key]["meses_periodo"] = "";
        }
        if(this.data[key]["prima_ventas"] == undefined){
          this.data[key]["prima_ventas"] = "";
        }
        if(this.data[key]["moneda"] == undefined){
          this.data[key]["moneda"] = "";
        }
        if(this.data[key]["costo_variable_minimo"] == undefined){
          this.data[key]["costo_variable_minimo"] = "";
        }
        if(this.data[key]["prima_de_deposito"] == undefined){
          this.data[key]["prima_de_deposito"] = "";
        }
        if(this.data[key]["cumplimiento"] == undefined){
          this.data[key]["cumplimiento"] = "";
        }
        if(this.data[key]["expirada"] == undefined){
          this.data[key]["expirada"] = "";
        }


        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["contratante"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["producto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["corredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ejecutivo"] + "</td>\n";
        // cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["asistente"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["vigencia_desde"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["vigencia_hasta"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["meses_periodo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["prima_ventas"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["moneda"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["costo_variable_minimo"]).format("0,0") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["prima_de_deposito"] + "</td>\n";
        //cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["cumplimiento"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+ this.data[key]["cumplimiento"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["expirada"] + "</td>\n";
        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    descargarExcelModal: function () {
      var cuerpo = "";
      var columnas = this.titlesDinamic;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      /* cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 style='border-right:.5pt solid black;" +
        xl689618 +
        "' >CostoVariableMinimo</td>\n";
      cuerpo += "</tr>\n";*/

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";

      //Data bloque 1
      for (var key in this.datosFormularioModal.data) {
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datosFormularioModal.data[key]["contratante"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datosFormularioModal.data[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datosFormularioModal.data[key]["producto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_00"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_00"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_01"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_01"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_02"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_02"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_03"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_03"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_04"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_04"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_05"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_05"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_06"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_06"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_07"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_07"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_08"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_08"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_09"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_09"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_10"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_10"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_11"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_11"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["total_ventas"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["total_ventas"]).format("0,0.00")) + "</td>\n";

        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },

    consulta_poliza: function () {
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasPoliza = false;

      this.datosFormulario.ejecutivo == "Todos"? "T" : this.datosFormulario.ejecutivo;
      this.datosFormulario.poliza == "" ? "" : this.datosFormulario.poliza;
      this.datosFormulario.moneda == "" ? "" : this.datosFormulario.moneda;

      var p_email = this.$session.get("mail");
      var p_ejecutivo = this.datosFormulario.ejecutivo;
      var p_poliza = this.datosFormulario.poliza;

      if (p_ejecutivo == "") {
        p_ejecutivo = "0";
      }

      return apiBaseAsegurado
        .consulta_poliza(p_email, p_ejecutivo, p_poliza)
        .then((response) => {
          response.data = this.keysMinuscula(response.data);

          var Listapoliza = response.data.res;
          for (var i = 0; i < Listapoliza.length; i++) {
            this.datosFormulario.poliza = Listapoliza[i]["marpoliza"];
            this.datosFormulario.moneda = "PO";
            this.datosFormulario.ejecutivo = Listapoliza[i]["ejecutivo"];
            this.hasPoliza = true;
          }
          this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje = error;
          this.variant = "danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },


  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    //this.buscar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.card-header {
  background-color: #00a7d4;
  color: #fff;
}

.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}

.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}
/*
.el-button {
  background: #00a7d4;
}*/
</style>

